import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AccountantCycle, _AccountingData, _CloseYearPeriod, _CloseYearPeriodAdjustments } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import useModal, { MODAL_md } from "../../../theme/Component/hooks/useModal";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { InputDate } from "../../../theme/Input/InputDate";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { SelectBusinessCore } from "../BusinessCore/SelectBusinessCore";



export const AccountantCycle = () => {

    const AccountantCycle = useDataBean(_AccountantCycle);
    const AccountingData = useDataBean(_AccountingData);
    const cuenta = useDataBean(_CloseYearPeriod);
    const cuentaclose = useDataBean(_CloseYearPeriodAdjustments);
    const [form, setForm] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
        ClosePyG: null,
        AccountantIDStr: null
    })
    const [DocInfotre, setDocInfotre] = useState<any>(null)
    const [modalviewdoctre, setModalviewdoctre] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [lastdate, setlastdate] = useState<any>(_single.getCurrenDate())
    const [modalcuenta, setModalcuenta] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcierretwo, setModalcierretwo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcerrar, setModalcerrar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallibro, setModallibro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcierre, setModalcierre] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalDel = useModal("Eliminar", MODAL_md);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        AccountantCycle.instance.getAccountantCyclesWithAdjustmentsUpto(lastdate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const closeAccountantPeriod = () => {

        // AccountantCycle.instance.closeAccountantPeriod(form.Year, form.Month, _single.getAccountID()).then(
        AccountantCycle.instance.closeAccountantPeriodThread(form.Year, form.Month, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Proceso iniciado, valide su bandeja de mensajes para ver el resultado');
                    setModalcierre({ ...modalcierre, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const updateAccountingData = () => {

        AccountingData.instance.updateAccountingData(AccountingData.bean.Year, AccountingData.bean.Month).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Actualizado');
                    setModallibro({ ...modallibro, "view": false });
                    // setDocs(resp.DocumentURL);
                    // setModaldoc({ ...modaldoc, "view": true });

                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        AccountantCycle.setBean({

        });
        setModalcierre({ ...modalcierre, "view": true });
    }
    const vermodal = () => {

        setModalcierre({ ...modalcierre, "view": true });
    }
    const vermodallibro = () => {

        setModallibro({ ...modallibro, "view": true });
    }
    const vermodalcuenta = () => {

        setModalcuenta({ ...modalcuenta, "view": true });
    }
    const vermodalcierre = () => {

        setModalcierretwo({ ...modalcierretwo, "view": true });
    }
    const vermodalcerrar = () => {

        setModalcerrar({ ...modalcerrar, "view": true });
    }
    const deleteItem = () => {
        AccountantCycle.instance.deleteLeftBatch(AccountantCycle.bean.IDAccountantCycle).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        AccountantCycle.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const closeYearPeriodForPyG = () => {
        cuenta.instance.closeYearPeriodForPyG(form.Year, cuenta.bean.AccountantIDStr, cuenta.bean.IDBusinessCore, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.DocumentURL) {
                    console.log(resp)
                    setDocInfotre(resp.DocumentURL);
                    setModalcuenta({ ...modalcuenta, "view": false });
                    setModalviewdoctre({ ...modalviewdoctre, "view": true })
                } else {
                    toast.error('Sin Documento');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const closeYearPeriodForAdjustments = () => {
        cuentaclose.instance.closeYearPeriodForAdjustments(form.Year, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                setModalcierretwo({ ...modalcierretwo, "view": false });
                toast.success('Realizado');
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const head = [
        { title: 'ID', property: 'IDAccountantCycle', visible: true },
        { title: 'Nombre', property: 'CycleName', visible: true },
        { title: 'Fecha Cierre', property: 'LastDate', visible: true },
        { title: 'Fecha Ejecución', property: 'Executed', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },
        { title: 'Ajustes de Cierre de Vigencia', property: 'IsAdjustment', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Crear Cierre Mensual', icono: 'ri-file-list-line', visible: single.canDelete(), evento: () => { setModalcierre({ ...modalcierre, "view": true }) } },
            { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: true, evento: () => { modalDel.open() }, },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Cierres Contables">
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="date" label="Fecha a consultar" value={lastdate} setDate={(e: any) => { setlastdate(e) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-save-line" clase="primary" eventClick={getLista}>Consultar</BasicButton>
                </div>
                <div className="row">

                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-git-repository-fill" clase="primary" eventClick={vermodallibro}>Actualizar Libros y Cuentas Contables</BasicButton>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-git-repository-fill" clase="primary" eventClick={vermodalcuenta}>Cerrar Cuentas de Resultado en Vigencia</BasicButton>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-git-repository-fill" clase="primary" eventClick={vermodalcierre}>Cerrar Período de Ajustes</BasicButton>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-mail-add-fill" clase="primary" eventClick={vermodal}>Crear Cierre Mensual</BasicButton>
                    </div>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={AccountantCycle.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {AccountantCycle.bean.Name}</strong>
                    </ModalConfirm>
                    <Modal modal={modalcierre} updateModal={setModalcierre} eventModal={closeAccountantPeriod}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor label='Mes' idSelect={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                <BasicSwitch estado={form.ClosePyG} label="Cerrar Cuentas de Resultado ?" eventChange={(e: any) => {
                                    setForm({ ...form, "ClosePyG": e })
                                }}></BasicSwitch>
                            </div>
                            {form.ClosePyG && <>
                                <div className="col-md-6">
                                    <SelectAccountantTree label="Cuenta de Resultado" jsonCode={form.AccountantIDStr} onChange={(e) => { setForm({ ...form, "AccountantIDStr": e.JsonCode }) }} />
                                </div>
                            </>}
                            <div className="col-md-6">
                                <BasicSwitch estado={form.IsAdjustment} label="Ajustes de Cierre de Vigencia" eventChange={(e: any) => {
                                    setForm({ ...form, "IsAdjustment": e })
                                }}></BasicSwitch>
                            </div> */}
                        </div>
                    </Modal>
                    <Modal modal={modallibro} updateModal={setModallibro} eventModal={updateAccountingData}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={AccountingData.bean.Year} onChange={(e) => { AccountingData.setBean({ ...AccountingData.bean, "Year": e }) }} />

                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor label='Mes' idSelect={AccountingData.bean.Month} onChange={(e) => { AccountingData.setBean({ ...AccountingData.bean, "Month": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalcuenta} updateModal={setModalcuenta} eventModal={closeYearPeriodForPyG}>
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector tittle="Vigencia" value={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectAccountantTree label="Cuenta de Cierre de Ingresos, Gastos y Costos" jsonCode={cuenta.bean.AccountantIDStr} onChange={(e) => { cuenta.setBean({ ...cuenta.bean, AccountantIDStr: e.JsonCode }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectBusinessCore label='Unidad de Negocio por Defecto' returnType="Object" idSelector={cuenta.bean.IDBusinessCore} onChange={(e) => { cuenta.setBean({ ...cuenta.bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalcierretwo} updateModal={setModalcierretwo} eventModal={closeYearPeriodForAdjustments}>
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector value={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalviewdoctre} updateModal={setModalviewdoctre}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer list={DocInfotre} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={deleteItem}>
                        <div>
                            <strong>Eliminar item {AccountantCycle.bean.Name}</strong>
                        </div>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}